export class TemplateService {
    
    /**
     * TOC 테이블 데이터를 Excel 파일로 내보냅니다.
     */
    static exportTOCToExcel(tableData, customCols = []) {
        const excelData = tableData.map(r => {
            const row = {
                "레벨": r.level,
                "목차명": r.title,
                "분량(P)": r.page,
                "상태": r.status,
                "세부내용": r.detail
            };
            customCols.forEach(col => {
                row[col.name] = r.custom ? r.custom[col.id] : "";
            });
            return row;
        });

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "TOC");
        
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        return new Blob([wbout], { type: 'application/octet-stream' });
    }

    /**
     * Excel 파일에서 TOC 데이터를 파싱합니다.
     */
    static async importTOCFromExcel(file) {
        console.log("TemplateService: Importing TOC from Excel:", file.name);
        const arrayBuffer = await file.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet); 
        console.log("TemplateService: Parsed JSON:", jsonData);
        
        if (!jsonData || jsonData.length === 0) return [];

        return jsonData.map(row => ({
            level: String(row["레벨"] || row["Level"] || row["lv"] || row["No"] || "1"),
            title: String(row["목차명"] || row["Title"] || row["목차"] || row["항목"] || "새 목차"),
            page: String(row["분량(P)"] || row["Page"] || row["분량"] || row["장수"] || "1"),
            status: String(row["상태"] || row["작성상태"] || row["Status"] || row["진행"] || "작성전"),
            detail: String(row["세부내용"] || row["Detail"] || row["내용"] || row["Description"] || ""),
            owner: String(row["담당자"] || row["Owner"] || row["담당"] || ""),
            custom: {}
        }));
    }

    /**
     * HTML/CSS를 받아 IFrame(샌드박스) 형태로 렌더링할 Blob URL을 반환합니다.
     * @param {string} html 
     * @param {string} css 
     */
    static createSandboxIframeURL(html, css) {
        const content = `
            <!DOCTYPE html>
            <html lang="ko">
            <head>
                <meta charset="UTF-8">
                <style>
                    body { margin: 0; padding: 0; display: flex; justify-content: center; align-items: center; min-height: 100vh; background-color: transparent; }
                    .slide { width: 960px; height: 540px; background: white; box-shadow: 0 4px 6px rgba(0,0,0,0.1); overflow: hidden; position: relative; }
                    ${css}
                </style>
            </head>
            <body>
                <div class="slide">
                    ${html}
                </div>
            </body>
            </html>
        `;
        const blob = new Blob([content], { type: 'text/html' });
        return URL.createObjectURL(blob);
    }
}
